module.exports = __webpack_public_path__ + "static/media/ujenzi.a98a7cc6.jpeg";